module.exports = __webpack_public_path__ + "img/20210731_144744.bcf896a4.jpg";